import { call, put, takeLatest } from "redux-saga/effects";
import { bienLaiThuApi } from "../../../api/bien-lai/bienLaiThuApi";
import { IBienLaiHuyRequest } from "../../../model/request/bien-lai/IBienLaiHuyRequest";
import { IBienLaiPagingRequest } from "../../../model/request/bien-lai/IBienLaiPagingRequest";
import { IBienLaiThu } from "../../../model/respone/bien-lai/IBienLaiThu";
import { IPagingBienLaiResult } from "../../../model/respone/bien-lai/IBienLaiThuPaging";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import {
  eBienLaiPagingActionTypeIds,
  IBienLaiPagingActionTypes,
} from "./../../action-types/bien-lai/IBienLaiPagingActionTypes";

export function* bienLaiPagingSaga(): any {
  yield takeLatest(eBienLaiPagingActionTypeIds.LOAD_START, loadWorker);
  yield takeLatest(eBienLaiPagingActionTypeIds.HUY_START, huyWorker);
  yield takeLatest(
    eBienLaiPagingActionTypeIds.EXPORT_EXCEL_BAO_CAO_START,
    exportExcelWorker
  );
  yield takeLatest(
    eBienLaiPagingActionTypeIds.PRINT_BAO_CAO_START,
    printWorker
  );
}

function* loadWorker(action: IBienLaiPagingActionTypes): any {
  const request = action.payload as IBienLaiPagingRequest;
  const res: IBaseRespone = yield call(bienLaiThuApi.SelectPaging, request);
  if (res.is_success) {
    var data = res.data as IPagingBienLaiResult;
    yield put(rootActions.bienLai.bienLaiPaging.LOAD_SUCCESS(data));
  } else {
    yield put(
      rootActions.bienLai.bienLaiPaging.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* huyWorker(action: IBienLaiPagingActionTypes): any {
  const request = action.payload as IBienLaiHuyRequest;
  const res: IBaseRespone = yield call(bienLaiThuApi.Huy, request);
  if (res.is_success) {
    var data = res.data as IBienLaiThu;
    yield put(rootActions.bienLai.bienLaiPaging.HUY_SUCCESS(data));
    yield put(
      rootActions.bienLai.bienLaiView.LOAD_START({
        hoc_ky: data.hoc_ky,
        id_sv: data.id_sv,
        nam_hoc: data.nam_hoc,
      })
    );
    yield put(
      rootActions.bienLai.bienLaiViewChiTiet.LOAD_START(data.id_bien_lai)
    );
  } else {
    yield put(
      rootActions.bienLai.bienLaiPaging.HUY_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* exportExcelWorker(action: IBienLaiPagingActionTypes): any {
  const request = action.payload as IBienLaiPagingRequest;
  const res: IBaseRespone = yield call(bienLaiThuApi.ExportExcel, request);
  if (res.is_success) {
    yield put(
      rootActions.bienLai.bienLaiPaging.EXPORT_EXCEL_BAO_CAO_SUCCESS(res.data)
    );
  } else {
    yield put(
      rootActions.bienLai.bienLaiPaging.EXPORT_EXCEL_BAO_CAO_ERRR(
        res?.message ?? "Thất bại"
      )
    );
  }
}

function* printWorker(action: IBienLaiPagingActionTypes): any {
  const request = action.payload as IBienLaiPagingRequest;
  const res: IBaseRespone = yield call(bienLaiThuApi.Print, request);
  if (res.is_success) {
    yield put(
      rootActions.bienLai.bienLaiPaging.PRINT_BAO_CAO_SUCCESS(res.data)
    );
  } else {
    yield put(
      rootActions.bienLai.bienLaiPaging.PRINT_BAO_CAO_ERRR(
        res?.message ?? "Thất bại"
      )
    );
  }
}
